export default __webpack_public_path__ + "static/media/133.4dc3eee5.png";